import { AppointmentApi } from '@/apis';
import RootStore from '.';
import BaseStore from './BaseStore';
import { makeObservable, flow, observable } from 'mobx';
import { AppointmentDetail, AppointmentTableItem } from '@/types/appointment';
import { ResponseData } from '@/types/http';
import { GetAllAppointmentRequest, GetAllAppointmentResponse } from '@/types/http-payload/appointment';
import { TableState } from '@tanstack/react-table';

export default class AppointmentStore extends BaseStore {
    api: AppointmentApi;
    appointmentList: AppointmentTableItem[] = [];
    appointment: AppointmentDetail = {} as AppointmentDetail;
    totalByStatus: Object = {};

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            appointmentList: observable,
            appointment: observable,
            totalByStatus: observable,
            getListAppointment: flow.bound,
            getAppointmentDetail: flow.bound
        });
        this.api = new AppointmentApi();
    }

    *getListAppointment(searchParams: GetAllAppointmentRequest, paging?: TableState) {
        try {
            const payload = { ...this.convertPagingFromTableToRequest(paging ?? this.paging), ...searchParams };
            const res: ResponseData<GetAllAppointmentResponse> = yield this.rootStore.apiStore.call(this.api, this.api.getAppointments, payload);
            if (res?.ok) {
                this.appointmentList = res.data.elements;
                this.paging = {
                    ...this.paging,
                    sorting: paging?.sorting ?? [],
                    pagination: this.convertPaginationFromRequestToTable(res.data.pagination)
                };
                this.totalRecord = res.data.pagination.totalRecord;
                this.totalByStatus = res.data.totalByStatus;
            }
        } catch (error) {
            console.log(error);
        }
    }

    *getAppointmentDetail({ code }: { code: string }) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getAppointment, code);
            if (res?.ok) {
                this.appointment = res.data;
            }
        } catch (error) {

        }
    }
}
